import styled from '@emotion/styled';
import { tokens } from '@galaxy-react/core';
import React from 'react';

type Props = {
  type?: 'success' | 'error';
};
export const StyledTag = styled('span')<{ disabled?: boolean }>({
  display: 'flex',
  alignItems: 'center',
  padding: '2px 8px',
  textAlign: 'center',
  background: '#E5EDF3',
  color: '#014F8C',
  borderRadius: 4,
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  lineHeight: 1.6,
  fontWeight: tokens.fontWeightSemibold,
  fontSize: tokens.fontSizeBase200,

  '&.success': {
    background: '#E6F0E6',
    color: '#0C6B0C',
  },
  '&.error': {
    background: '#FCE8E6',
    color: '#961818',
  },
});
const Tag = (props: React.PropsWithChildren<Props>) => {
  return <StyledTag className={props.type}>{props.children}</StyledTag>;
};

export default Tag;
